module.exports = __webpack_public_path__ + "static/media/volunteer-jewel.59f249f0.jpg";